// extracted by mini-css-extract-plugin
export default {"match-substring":"WzabOORy08p9RsW","disabled":"GAX6YQocuujevsx"};